// @flow

import { createImageUrl } from '@nrk/serum-imagecrop-utils'
import { background, backgroundOverlay } from '../stylesheets/background.css'
import { alignCenter, alignMiddle } from '../stylesheets/alignment/index.css'
import { createSrcSet, supportedWidths } from '../utils/imageUtils'

type overlayType = {
  opacity: ?string | ?number,
  color: ?string
}

type polopolyHandlerTypeProps = {
  polopolyId: string,
  backgroundColor: ?string,
  alignment: ?Array<string>,
  overlay: ?overlayType
}

export const polopolyComponent = {
  type: 'polopoly',
  render(id: string, props: polopolyHandlerTypeProps, bgInnerHTML: ?string = ''): string {
    const { polopolyId, alignment, overlay } = props

    const defaultUrl = createImageUrl({ id: polopolyId, width: 1600, ratio: '1:1' })
    const desktopSourceSet = createSrcSet(polopolyId, '1:1', supportedWidths)
    const mobileSourceSet = createSrcSet(polopolyId, '3:4', supportedWidths)

    const overlayElement = overlay ?
      `<div class="${backgroundOverlay}" style="background-color: ${props.overlay
          .color || '#000'}; opacity: ${props.overlay.opacity || 0.8}"></div>` :
      ''

    const imgStyle = 'min-width: 100%; min-height: 100%; position: relative;'
    const alignmentClasses = alignment ?
      alignment.join(' ') :
      [alignMiddle, alignCenter].join(' ')

    return `
      <div id="${id}" class="${background}">
        <picture style="object-fit: cover;">
        <source media="(min-aspect-ratio: 3/4)" srcset="${desktopSourceSet}">
        <img src="${defaultUrl}" srcset="${mobileSourceSet}" class="${alignmentClasses}" style="${imgStyle}">
        </picture>
        ${bgInnerHTML}
        ${overlayElement}
      </div>`
  }
}

export function getPolopolyImageElement(
  polopolyId: string,
  alignmentClasses: string = ''
): string {
  const defaultUrl = createImageUrl({ id: polopolyId, width: 1600, ratio: '1:1' })
  const desktopSourceSet = createSrcSet(polopolyId, '1:1', supportedWidths)
  const mobileSourceSet = createSrcSet(polopolyId, '3:4', supportedWidths)

  const imgStyle =
    'position: absolute; top: 50%; left: 50%; -webkit-transform: translate(-50%, -50%);-ms-transform: translate(-50%, -50%);transform: translate(-50%, -50%);'
  return `
    <picture>
      <source media="(min-aspect-ratio: 3/4)" srcset="${desktopSourceSet}">
      <img src="${defaultUrl}" srcset="${mobileSourceSet}" class="${alignmentClasses}" style="${imgStyle}">
    </picture>`
}



// WEBPACK FOOTER //
// ./src/shared/components/polopoly.js